import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { ContractTermsAgencyModel } from 'src/app/Model/ContractTermsAgency.model';
import { RequestModel } from 'src/app/Model/Request.model';
import { VRequestStatusProcessModel } from 'src/app/Model/VRequestStatusProcess.Model';
import { VStatusDocumentUpdated } from 'src/app/Model/VStatusDocumentUpdated';
import { ComService } from 'src/app/Services/com-service/com.service';
import { DocumentService } from 'src/app/Services/document/Documentservice';
import { EthicsComplianceService } from 'src/app/Services/EthicsCompliance/ethics-compliance.service';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { RequestService } from 'src/app/Services/request/request.service';
import { RequesStatusService } from 'src/app/Services/RequestStatus/RequesStatus.service';
import { TrainingService } from 'src/app/Services/Training/Training.service';
import Swal from 'sweetalert2';
import { FormSectionsService } from 'src/app/Services/FormSections/form-sections.service';
import { Sections } from 'src/app/Model/Enums/Sections.enum';
import { Flows } from 'src/app/Model/Enums/Flow.enums';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {

  notifierSubscription: Subscription = this.dataService.subjectNotifier.subscribe(notified => {
    // originator has notified me. refresh my data here.
    this.ngOnInit()
  });

  public request: RequestModel;
  public idrequest = this.lsService.getLSItem("IdRequest");
  public requestCode: string;
  public showDocument: boolean;
  public ContractTermsAgency: ContractTermsAgencyModel
  public ContractTermsBool: boolean
  public TrainingBool: boolean
  public ContractFlowStateBool: boolean
  public AprovedFlowStateBool: boolean
  public IsConnect: boolean
  public Isrejected: boolean
  public tl: boolean = false;
  public isApproved: boolean
  public CompletedDocuments: boolean
  validEthicsCompliance: boolean
  validAccessLetter: boolean
  public NotShow: boolean
  public ViewTraining: boolean
  public urlStatus: boolean
  lstStatuses: VRequestStatusProcessModel[];
  updatedDocumentStatus: VStatusDocumentUpdated[];
  crmPreApproval: boolean;

  @ViewChild('popUp',{static: false})
  popUp: ElementRef;

  constructor(
    private readonly requestService: RequestService,
    private readonly DocumentService: DocumentService,
    private readonly TrainingService: TrainingService,
    private readonly activeRoute: ActivatedRoute,
    private readonly RequesStatusService: RequesStatusService,
    private readonly dataService: ComService,
    private readonly translate: TranslateService,
    private readonly SpinnerService: NgxSpinnerService,
    public ethicsComplianceService: EthicsComplianceService,
    private readonly lsService : SessionStorageService,
    private readonly formSectionService: FormSectionsService
  ) { }

  async ngOnInit(): Promise<void> {

    if (this.activeRoute.snapshot.children[0].params.requestcode == undefined) {
      await this.GetRequestById()
      switch (this.activeRoute.snapshot.children[0].routeConfig.path) {
        case "StatusUpdateMessage":
          this.urlStatus = true;
          break;
        case "AgencyPolicy":
          this.urlStatus = true;
          break;
        case "AgencyExtraWarranty":
          this.urlStatus = true;
          break;
        case "TerminationLetter/:id":
          this.tl = true;
          break;
        default:
          this.urlStatus = false;
          break;
      }
    }
    else {
      this.requestCode = this.activeRoute.snapshot.children[0].params.requestcode
      if (this.requestCode.includes('AVD')) {
        await this.GetRequestByCode()
      }
      else {
        this.lsService.setLSItem("IdRequest", this.requestCode);
        await this.GetRequestById()
      }

    }
    await this.updateRequest()
  }

  ngOnDestroy() {
    this.notifierSubscription.unsubscribe();
  }

  public async GetRequestByCode() {

    if (this.requestCode != undefined) {
      await this.DocumentService.getRequestByCode(this.requestCode)
        .then(async (res) => {
          if (res != null) {
            this.request = res
            
            if (this.request.IdFlow == Flows.Flujo1_1 || this.request.IdFlow == Flows.Flujo2_2 || 
              this.request.IsUpdateCrm || this.request.IdFlow == Flows.NuevoIATACOLContrato || 
              this.request.IdFlow == Flows.NuevoIATAEXT || this.request.IdFlow == Flows.Primeringreso) {
              this.NotShow = true
            } else {
              this.NotShow = false
            }
            if (this.request.IdFlow == Flows.Flujo4_1 || this.request.IdFlow == Flows.Flujo4_2 || this.request.IdFlow == Flows.Flujo5_1){
              this.ViewTraining = true
            } else {
              this.ViewTraining = false
            }
            this.lsService.setLSItem('RequestCode', res.RequestCode)
            this.lsService.setLSItem('IdRequest', res.Id.toString())
            this.lsService.setLSItem('type', res.ConnectionType.toString())
          }
          else {
            await Swal.fire({
              title: 'Error!',
              text: this.translate.instant('Home.Error'),
              icon: 'error'
            }
            )
          }
        }
        )
    }
    this.GetRequestById()
  }

  public async GetRequestById() {
    this.idrequest = this.lsService.getLSItem("IdRequest");

    if (this.idrequest != undefined) {
      await this.requestService.getRequestById(this.idrequest)
        .then(async (res) => {
          if (res != null) {

            this.request = res

            if (this.request.IdFlow == Flows.Flujo1_1 || this.request.IdFlow == Flows.Flujo2_2 || 
              this.request.IsUpdateCrm || this.request.IdFlow == Flows.NuevoIATACOLContrato || 
              this.request.IdFlow == Flows.NuevoIATAEXT || this.request.IdFlow == Flows.Primeringreso) {
              this.NotShow = true
            } else {
              this.NotShow = false
            }
            if (this.request.IdFlow == Flows.Flujo4_1 || this.request.IdFlow == Flows.Flujo4_2 || this.request.IdFlow == Flows.Flujo5_1){
              this.ViewTraining = true
            } else {
              this.ViewTraining = false
            }
            this.lsService.setLSItem('RequestCode', res.RequestCode)
            this.lsService.setLSItem('IdRequest', res.Id.toString())
            this.lsService.setLSItem('type', res.ConnectionType.toString())
          }

          else {
            await Swal.fire({
              title: 'Error!',
              text: this.translate.instant('Home.Error'),
              icon: 'error'
            }
            )
          }
        }
        )
    }
  }



  async updateRequest() {
    this.CompleteTotalRequest()
    this.getContractTermsAgencyByCode()
  }

  async blockedDocuments() {
    Swal.fire({
      title: 'Error!',
      text: this.translate.instant('Main.Request'),
      icon: 'error'
    })

  }

  blockedApproval() {

    Swal.fire({
      title: 'Error!',
      text: this.translate.instant('Main.Documents'),
      icon: 'error'
    })

  }

  blockedContract() {

    Swal.fire({
      title: 'Error!',
      text: this.translate.instant('Main.Flows'),
      icon: 'error'
    })

  }


  redirectContinue() {

    window.location.replace(`request/agency-home`);
  }

  redirectRequest() {
    window.location.replace(`Register/Main/Request`);
  }

  async redirectDocuments() {

    //Validación automática de CRM

    if((this.request.IdFlow == 4 || this.request.IdFlow == 5 || this.request.IdFlow == 6 || this.request.IdFlow == 7 || this.request.IdFlow == 17 || this.request.IdFlow == 18) 
    && this.request.RequestStatus == null) {
      await this.SpinnerService.show()
      await this.requestService.crmRequestValidation(this.request.Id).then(async (res) => {
        this.crmPreApproval = res;
      })
      await this.SpinnerService.hide()
      if(this.crmPreApproval)
      window.location.replace(`Register/Main/Document`);
      else{
        Swal.fire({
          html: this.popUp.nativeElement,
          width: 600,
          showCloseButton: true,
          confirmButtonText: this.translate.instant('Document.Label.Continue'),
          customClass: {
            confirmButton: 'btn btn-dark',
          },
          buttonsStyling: false
        }).then((res) => {
          this.redirectRequest();
        })
      }
    }
    else{
      window.location.replace(`Register/Main/Document`);
    }
    
  }

  redirectAcceptTerms() {

    
    window.location.replace(`Register/Main/AcceptTerms`);
  }

  redirectMyMessages() {

    
    window.location.replace(`Register/Main/MyMessages`);
  }

  redirectTraining() {
    window.location.replace(`Register/Main/training`);
  }

  redirectConsulData() {
    window.location.replace(`Register/Main/ConsultConnectionData`);
  }

  redirectConsulDataDocument() {
    window.location.replace(`Register/Main/ConsultConnectionDocuments`);
  }

  redirectApplicationApproval() {
    window.location.replace(`Register/Main/ApplicationApproval`);
  }
  redirectAccessRequest() {

    if (this.ContractTermsBool)
      window.location.replace(`Register/Main/AccessRequest`);
    else {
      Swal.fire({
        title: 'Error!',
        text: this.translate.instant('Main.TermsAndConditions'),
        icon: 'error'
      })
    }
  }
  
  /**
   * CompleteTotalRequest
   */
  public async CompleteTotalRequest() {
    if(this.request != undefined && this.request.Id != undefined){
      this.lstStatuses = await this.requestService.getRequestStatuses(this.request.Id)
      let validSections: boolean[] = []
      

      if (this.request != null) {
        await this.checkEthicsCompliance(this.request)
      }
      if(this.request.IdFlow != undefined){
        let forms = await this.formSectionService.get(this.request.IdFlow)
        forms = forms.sort((a,b) => a.Order - b.Order)
        forms.forEach(section => {
          if(section.IdComponent == Sections.Generalidades){
            validSections.push(this.request.completeOverview())
          }
          else if(section.IdComponent == Sections.Localizacion){
            validSections.push(this.request.completeLocation())
          }
          else if(section.IdComponent == Sections.Identicacion){
            validSections.push(this.request.completeIdentification())
          }
          else if(section.IdComponent == Sections.RepLegal){
            validSections.push(this.request.completeLegal())
          }
          else if(section.IdComponent == Sections.Accionistas){
            validSections.push(this.request.completePartners())
          }
          else if(section.IdComponent == Sections.AdminPortal){
            validSections.push(this.request.completeAdminPortal())
          }
          else if(section.IdComponent == Sections.Firmas){
            validSections.push(this.request.completeSignatures())
          }
          else if(section.IdComponent == Sections.AccesoInventario){
            let validAccessLetter = this.validAccessLetter
            validSections.push(validAccessLetter)
          }
          else if(section.IdComponent == Sections.Etica){
            let validEthics = this.validEthicsCompliance
            validSections.push(validEthics)
          }
        })
        this.showDocument = validSections.every(x => x)
      }
      return this.showDocument 
    }
  }

  public async checkEthicsCompliance(rq): Promise<boolean> {

    this.request = rq

    if (this.request.IdFlow == Flows.Flujo1_1 || this.request.IdFlow == Flows.Flujo2_2 || 
      this.request.IsUpdateCrm || this.request.IdFlow == Flows.NuevoIATACOLContrato || 
      this.request.IdFlow == Flows.NuevoIATAEXT || this.request.IdFlow == Flows.Primeringreso ||
      this.request.IdFlow == Flows.CambioRepresentanteAdministrador) {
      this.NotShow = true
    } else {
      this.NotShow = false
    }

    let EntityTypeBool: boolean;
    let AviancaPoliciesBool: boolean;
    let PoliticsExposedBool: boolean;
    let ConflictInterestBool: boolean;
    let TermsCoditionsBool: boolean;
    let AccessLetterBool: boolean;

    if (this.request != undefined) {
      let oldIdBillingPeriod = this.request.IdBillingPeriod

      this.request.IdBillingPeriod = 2;
      await this.checkEntityTypeBool(this.request).then(res => {
        EntityTypeBool = res
      });

      this.request.IdBillingPeriod = 3;
      await this.checkEntityTypeBool(this.request).then(res => {
        AviancaPoliciesBool = res
      });

      this.request.IdBillingPeriod = 4;
      PoliticsExposedBool = await this.checkEntityTypeBool(this.request)

      this.request.IdBillingPeriod = 5;
      ConflictInterestBool = await this.checkEntityTypeBool(this.request)

      this.request.IdBillingPeriod = 6;
      TermsCoditionsBool = await this.checkEntityTypeBool(this.request)

      this.request.IdBillingPeriod = 7;
      AccessLetterBool = await this.checkEntityTypeBool(this.request)

      this.request.IdBillingPeriod = oldIdBillingPeriod
    }

    let response
    if (EntityTypeBool && AviancaPoliciesBool && PoliticsExposedBool && ConflictInterestBool && TermsCoditionsBool) {
      this.validEthicsCompliance = true;
    }
    else {
      this.validEthicsCompliance = false;
    }

    if (AccessLetterBool) {
      this.validAccessLetter = true;
    }
    else {
      this.validAccessLetter = false;
    }
    return response

  }


  public async checkEntityTypeBool(section: RequestModel) {
    let response: boolean
    if(!Number.isNaN(section.Id)){
      await this.ethicsComplianceService.getAnswersBySection(section).then(res => {
        if (res.length != 0) {
          response = true
        } else {
          response = false
        }
        return response;
      });
    }
    return response;
  }



  public async getContractTermsAgencyByCode() {
    if(this.request != undefined && this.request.RequestCode != undefined){
      await this.DocumentService.getContractTermsAgencyByCode(this.request.RequestCode).then(
        async (res) => {
          this.ContractTermsAgency = res;
          if (this.ContractTermsAgency == undefined) {
  
            this.ContractTermsBool = false
  
            this.SpinnerService.hide()
  
            return true
  
          } else {
  
            this.ContractTermsBool = true
  
            this.SpinnerService.hide()
  
            return false
          }
  
  
        }
      );
      this.getDocumentsInRevision(this.request.Id)
      
      this.getValidateTermsAndConditions(this.request.Id)
      this.getTrainingFlowState(this.request.RequestCode)
      this.getValidateTraining(this.request.Id)
      await this.getDocumentsApproval(this.request.Id)
    }
  }


   public async getTrainingFlowState(ReuqestCode) {
    await this.TrainingService.getTrainingFlowState(ReuqestCode).then(resp => {
      this.TrainingBool = resp;
    })
  }



  //----------------------------------------------------------------------------------------------//
  public async getDocumentsInRevision(RequestId) {
    let documentsReady = true

    await this.DocumentService.getDocumentsInRevision(RequestId).then(resp => {
      documentsReady = resp.Approved

    })

    await this.DocumentService.GetStatusDocumentUpdatedByIdRequest(RequestId).then(async (resp) =>{
      this.updatedDocumentStatus = resp
    })
    if(this.updatedDocumentStatus.length != 0){
      this.updatedDocumentStatus.forEach(x => {
        if(x.Approve != true && x.ReviewDocument != true){
          documentsReady = false
        }
      })
    }
    this.CompletedDocuments = documentsReady
  }

  public async getDocumentsApproval(RequestId) {
    await this.DocumentService.getDocumentsApproval(RequestId).then(resp => {
      this.AprovedFlowStateBool = resp.Approved
    })
  }



  public async getValidateTermsAndConditions(RequestId) {
    await this.DocumentService.getValidateTermsAndConditions(RequestId).then(resp => {
      this.ContractTermsBool = resp.Approved
    })
  }

  public async getValidateTraining(RequestId) {
    await this.DocumentService.getValidateTraining(RequestId).then(resp => {
      this.TrainingBool = resp.Approved
    })
  }
}
